import { render, staticRenderFns } from "./GDPR.vue?vue&type=template&id=2bb193c7&"
import script from "./GDPR.vue?vue&type=script&lang=ts&"
export * from "./GDPR.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports